import { createActions, createReducer } from 'reduxsauce'

import DetalhesRemuneracaoService from '../../servicos/DetalhesRemuneracaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesRemuneracaoInicio: [],
    buscaDetalhesRemuneracaoSucesso: ['detalhesRemuneracao'],
    buscaDetalhesRemuneracaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaDetalhesRemuneracao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesRemuneracaoInicio())
        let serv = new DetalhesRemuneracaoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDetalhesRemuneracaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesRemuneracaoErro(error)))
    }
}

const buscaDetalhesRemuneracaoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaDetalhesRemuneracaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaDetalhesRemuneracaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.detalhesRemuneracao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_REMUNERACAO_INICIO]: buscaDetalhesRemuneracaoInicio,
    [Types.BUSCA_DETALHES_REMUNERACAO_ERRO]: buscaDetalhesRemuneracaoErro,
    [Types.BUSCA_DETALHES_REMUNERACAO_SUCESSO]: buscaDetalhesRemuneracaoSucesso,
})
